import React from 'react';
import { Box, Button, TextField, useTheme } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../components/Header"; // Verifique se o caminho está correto
import { mockDataExpenses } from "../../../data/mockData";

const DetalhesDespesa = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const expense = mockDataExpenses.find((expense) => expense.id === parseInt(id));

  const isPending = expense.estado === "Pendente";

  const handleApprove = () => {
    // Lógica para aprovar a despesa
    console.log("Despesa aprovada!");
  };

  return (
    <Box m="20px">
      <Header title="Detalhes da Despesa" subtitle="Veja os detalhes da despesa" />
      <Box
        component="form"
        sx={{
          display: 'grid',
          gap: '30px',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          backgroundColor: theme.palette.primary.main,
          padding: '20px',
          borderRadius: '8px',
          "& > div": { gridColumn: "span 4" },
        }}
      >
        <TextField
          label="Data"
          name="date"
          value={expense.data}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Projeto"
          name="project"
          value={expense.projeto}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Valor Total"
          name="totalValue"
          value={expense.totalValue}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Tipo de Despesa"
          name="expenseType"
          value={expense.tipoDespesa}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: "span 2" }}
        />
        <TextField
          label="Percurso Completo"
          name="route"
          value={expense.percurso}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: expense.tipoDespesa === "Deslocação em viatura própria" ? "span 2" : "span 3" }}
        />
        {expense.tipoDespesa === "Deslocação em viatura própria" && (
          <TextField
            label="Kms"
            name="kms"
            value={expense.kms}
            fullWidth
            variant="filled"
            disabled
            sx={{ gridColumn: "span 1" }}
          />
        )}
        <TextField
          label="Notas"
          name="note"
          value={expense.note}
          fullWidth
          variant="filled"
          disabled
          sx={{ gridColumn: "span 4" }}
        />
        
        <Box display="flex" justifyContent="space-between" sx={{ gridColumn: "span 4" }}>
        <Button variant="contained" color="secondary" onClick={() => navigate("/despesas")}>
            Voltar
          </Button>
        {isPending && (
            <Button type="button" onClick={handleApprove} color="success" variant="contained">
              Aprovar Despesa
            </Button>
        )}          
        </Box>
      </Box>
    </Box>
  );
};

export default DetalhesDespesa;
